import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import AboutCustomView from "../views/AboutCustomView.vue";
import TechnicalAssistanceView from "../views/TechnicalAssistanceView.vue";
import ServicesView from "../views/ServicesView.vue";
import ServiceItemView from "../views/ServiceItemView.vue";
import ProductItemView from "../views/productItem/Index.vue";
import ProductListView from "../views/ProductListView.vue";
// import ServiceCard from "../views/ServiceCard.vue";
// import ArticleCustomView from "../views/ArticleCustomView.vue";
import ListCustomView from "../views/ListCustomView.vue";
import ArticleCustomView from "../views/ArticleCustomView.vue";
import ArticleCard from "../components/cards/ArticleCard.vue";
import ContactResponseView from "../views/ContactResponseView.vue";
import PolicyPrivacyView from "../views/PolicyPrivacyView.vue";
import Error404View from "../views/Error404View.vue";
import ServiceCard from "../components/cards/ServiceCard.vue";
import ServiceChannels from "../views/ServiceChannels.vue";

Vue.use(VueRouter);

const routes = [
  {
    name: "",
    path: "/",
    component: HomeView,
  },
  {
    name: "Sobre",
    path: "/sobre",
    component: AboutCustomView,
    meta: {
      about: "about",
      team: "team",
      mission: "mission",
    },
  },
  {
    name: "Serviços",
    path: "/servicos",
    component: ServicesView,
    meta: {
      mod: "services",
      cardComponent: ServiceCard,
    },
  },
  {
    name: "Serviço",
    path: "/servicos/:item",
    component: ServiceItemView,
    meta: {
      mod: "services",
    },
  },
  {
    name: "Produtos",
    path: "/produtos",
    component: ProductListView,
  },
  {
    name: "Produto",
    path: "/produtos/:item",
    component: ProductItemView,
  },
  {
    name: "Novidades",
    path: "/novidades",
    component: ListCustomView,
    meta: {
      mod: "articles",
      cardComponent: ArticleCard,
    },
  },
  {
    name: "Novidade",
    path: "/novidades/:item",
    component: ArticleCustomView,
    meta: {
      mod: "articles",
    },
  },
  {
    name: "Assistência Técnica",
    path: "/assistencia-tecnica",
    component: TechnicalAssistanceView,
    meta: {
      mod: "technical-assistance",
    },
  },
  {
    name: "Canais de Atendimento",
    path: "/atendimento",
    component: ServiceChannels,
  },
  {
    name: "Obrigado!",
    path: "/fale-conosco/obrigado",
    component: ContactResponseView,
  },
  {
    name: "Política de Privacidade",
    path: "/politica-de-privacidade",
    component: PolicyPrivacyView,
  },
  {
    path: "/erro404",
    name: "Erro 404",
    component: Error404View,
  },
  {
    path: "*",
    component: Error404View,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

export default router;
